/**
 * List of all the features that should be tracked by TrackProFeatures.
 * {
 *   id: ..., // The ID to look up the feature by
 *   feature_name: ..., // The name of the feature. Can be used to lookup if the user has this feature
 *   user_type: ..., // The type of user that can have this feature. pro, free or any (either pro or free)
 * }
 */
const features = [
    {
        id: 'portfolio',
        feature_name: 'portfolio',
        user_type: 'any',
    },
    {
        id: 'video',
        feature_name: 'video',
        user_type: 'any',
    },
    {
        id: 'testimonials',
        feature_name: 'testimonials',
        user_type: 'any',
    },
    {
        id: 'contact_me',
        feature_name: 'contact_me',
        user_type: 'any',
    },
    {
        id: 'spotlight',
        feature_name: 'pro_spotlights',
        user_type: 'pro',
    },
    {
        id: 'spotlight_trial',
        feature_name: 'pro_spotlights',
        user_type: 'free',
    },
]

module.exports = features
